module.exports = __webpack_public_path__ + "img/Left Barbell.e3059cd7.png";